// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__SU7eb","header":"PatientQuestionnaire_header__3eVTu","info":"PatientQuestionnaire_info__2wzqV"};